import React from 'react';
import ReactDOM from 'react-dom';

class Portal extends React.Component {
    constructor(props) {
        super(props);
        this.root = document.getElementById(props.id);
        this.staticClassNames = this.root.className;
        this.state = {
            classes: ((props.className) ? this.className = props.className : undefined)
        }
    }
    static getDerivedStateFromProps(props) {
        return {
            classes: props.className
        };
    }
    render() {
        if (this.state.classes) {
            let classNames = this.staticClassNames;
            this.state.classes.split(' ').map(className => {
                if (className !== '') classNames += (classNames === '' ? '' : ' ') + className.trim();
            });
            if (this.root.className !== classNames) this.root.className = classNames;
        } else {
            this.root.className = '';
        }

        return ReactDOM.createPortal(
            this.props.children,
            this.root,
        );
    }
}

export default Portal;